import React, { useState } from "react";

const FileNameWithTooltips = ({ name }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });

  const handleMouseEnter = (e) => {
    const { clientX, clientY } = e;
    setTooltipPos({ x: clientX, y: clientY });
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <>
      <span
        className="truncate file-size-of-subheading cursor-default"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {(name?.length > 25 ? name.slice(0, 25) + "..." : name) || "N/A"}
      </span>

      {showTooltip && (
        <div
className="fixed z-[9999] bg-white cursor-pointer text-[#B793ED] underline text-sm px-3 py-1 rounded shadow-md border border-gray-300"
          style={{
            top: tooltipPos.y - 40, // or adjust value like -30 based on your tooltip height

            left: tooltipPos.x + 1,
            whiteSpace: "nowrap",
            pointerEvents: "none", // ensure hover doesn't flicker
          }}
        >
          {name}
        </div>
      )}
    </>
  );
};

export default FileNameWithTooltips;
